export default __webpack_public_path__ + "static/media/logo.eb535ae7.svg";